import { format } from 'date-fns';

export async function pushDatalayer(datalayer = {}) {
    const gclId = sessionStorage.getItem('gclid') ? sessionStorage.getItem('gclid') : null;
    const utmSource = sessionStorage.getItem('utm_source') ? sessionStorage.getItem('utm_source') : null;
    const utmMedium = sessionStorage.getItem('utm_medium') ? sessionStorage.getItem('utm_medium') : null;

    const datalayerData = {
        ...datalayer,
        timestamp: format(new Date(), 'yyyy-MM-dd*HH:mm:ss'),
        device: window.matchMedia('(min-width: 768px)').matches ? 'desktop' : 'mobile',
        environment: getEnvironment(),
        platform: 'web',
        user_id: await getClientId(),
        user_login: 'null',
        country_code: (window?.navigator?.language || 'null')?.toLocaleLowerCase(),
        country_language: (window?.navigator?.language || 'null')?.toLocaleLowerCase(),
        utm_medium: utmMedium,
        utm_source: utmSource,
        gclid: gclId,
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(datalayerData);
}

export function getClientId() {
    return new Promise((resolve) => {
        if (typeof window.ga !== 'undefined') {
            window.ga(() => {
                let clientId;
                window.ga.getAll().forEach(tracker => {
                    clientId = clientId || tracker.get('clientId');
                });
                resolve(clientId || 'null');
            });
        } else {
            resolve('null');
        }
    });
}

function getEnvironment() {
    const host = window.location.host;

    if (host.includes("qlico")) return 'dev';
    if (host.includes("acceptance")) return 'acc';
    if (host.includes("production")) return 'prod';

    return 'live';
}
